<template>
  <!-- <textarea ref="tinycode" v-model="value"></textarea> -->
  <div>
    <div class="ui four item top attached tabular menu" ref="tabs">
      <a class="active item" data-tab="html" v-show="show_html">
        <i class="code icon"></i> {{ $t("html") }}</a
      >
      <a class="item" data-tab="js" v-show="show_js">
        <i class="js icon"></i> {{ $t("javascript") }}</a
      >
      <a class="item" data-tab="css" v-show="show_css">
        <i class="css3 icon"></i> {{ $t("css") }}</a
      >
      <a class="item" data-tab="preview" v-show="show_preview"
        ><i class="eye icon"></i> {{ $t("preview") }}</a
      >
    </div>
    <div
      class="ui bottom attached active tab segment"
      data-tab="html"
      v-show="show_html"
    >
      <code-editor
        v-model="content.html"
        type="html"
        icon="html5"
        theme="monokai"
        ref="html_code_editor"
        :title="$t('html code')"
        :show_format="true"
        :header_menus="html_header_menus"
      ></code-editor>
    </div>
    <div class="ui bottom attached tab segment" data-tab="js" v-show="show_js">
      <code-editor
        v-model="content.js"
        type="javascript"
        icon="js"
        theme="monokai"
        ref="js_code_editor"
        :title="$t('code')"
        :show_format="true"
        :header_menus="mixin_header_menus"
      ></code-editor>
    </div>
    <div
      class="ui bottom attached tab segment"
      data-tab="css"
      v-show="show_css"
    >
      <code-editor
        v-model="content.css"
        type="css"
        icon="css3"
        theme="monokai"
        ref="css_code_editor"
        :title="$t('css code')"
        :show_format="true"
      ></code-editor>
    </div>
    <div
      class="ui bottom attached tab segment"
      data-tab="preview"
      v-html="content.html"
      v-show="show_preview"
    ></div>
  </div>
</template>

<script>
// import Editor from "vue2-ace-editor";
// import HtmlToolbar from "./HtmlToolbar.vue";
import { html, js, css } from "js-beautify";
import CodeEditor from "@/components/code_editor/Index";
import { local_api, success_toast } from "@/utils";
// import clone from "@/utils";

export default {
  name: "Wysywyg",
  props: {
    value: Object,
    show_html: { type: Boolean, default: true },
    show_js: { type: Boolean, default: true },
    show_css: { type: Boolean, default: true },
    show_preview: { type: Boolean, default: true },
  },
  components: { /*Editor, HtmlToolbar,*/ CodeEditor },
  data() {
    return {
      content: {
        html: "",
        js: "",
        css: "",
      },
      templates: [],
    };
  },
  computed: {
    html_header_menus() {
      let vm = this;
      return [
        {
          tooltip: this.$t("format code"),
          icon: "wrench",
          buttons: this.templates
            .filter((t) => t.type == "html")
            .map((n) => {
              return {
                icon: n.icon,
                text: vm.$t(n.name),
                click: function () {
                  vm.$refs.html_code_editor.insert_content(n.template);
                },
              };
            }),
        },
      ];
    },
    mixin_header_menus() {
      let vm = this;
      return [
        {
          tooltip: this.$t("format code"),
          icon: "wrench",
          buttons: this.templates
            .filter((t) => t.type == "mixin")
            .map((n) => {
              return {
                icon: n.icon,
                text: vm.$t(n.name),
                click: function () {
                  vm.$refs.js_code_editor.insert_content(n.template);
                },
              };
            }),
        },
      ];
    },
  },
  created() {
    // let scriptsToAdd = [
    //   "https://cdn.tiny.cloud/1/sgmn587nhktuqimhemzg39fwlli6bsytpob6b57b4ss7h9dl/tinymce/5/tinymce.min.js",
    //   "https://cdn.tiny.cloud/1/sgmn587nhktuqimhemzg39fwlli6bsytpob6b57b4ss7h9dl/tinymce/5/jquery.tinymce.min.js",
    // ];
    // scriptsToAdd.map((s) => {
    //   var scriptTag = document.createElement("script");
    //   scriptTag.src = s;
    //   document.getElementsByTagName("head")[0].appendChild(scriptTag);
    // });
    let vm = this;
    local_api(vm, "post", "/system/do-get-templates")
      .then((templates) => {
        vm.templates = templates;
      })
      .catch((err) => {
        success_toast(err);
      });
  },
  methods: {
    init() {
      window.jQuery(this.$refs.tabs).find(".item").tab();
    },
    init_code(type) {
      require(`brace/mode/${type}`);
      require("brace/theme/monokai");
    },
    html_content_changed(content) {
      this.content.html = content;
      this.emit_update_signal();
    },
    js_content_changed(content) {
      this.content.js = content;
      this.emit_update_signal();
    },
    css_content_changed(content) {
      this.content.css = content;
      this.emit_update_signal();
    },
    emit_update_signal() {
      this.$emit("input", this.content);
    },
    format_html_code() {
      let ress = html(this.content.html, {
        indent_size: 2,
        indent_char: " ",
      });
      this.content.html = ress;
    },
    format_js_code() {
      console.log("js");
      let ress = js(this.content.js, { indent_size: 2, indent_char: " " });
      this.content.js = ress;
    },
    format_css_code() {
      console.log("css");
      let ress = css(this.content.css, { indent_size: 2, indent_char: " " });
      this.content.css = ress;
    },
  },
  mounted() {
    if (this.value) this.content = this.value;
    window.jQuery(this.$refs.tabs).find(".item").tab();
  },
  watch: {
    value() {
      if (this.value) this.content = this.value;
    },
  },
};
</script>
